<template>
  <div>
    <h1 v-if="this.$route.params.id">Editar Concesionario</h1>
    <h1 v-if="!this.$route.params.id">Registrar Concesionario</h1>
      <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="addConcesionario()" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre">
                <a-input
                  placeholder="Nombre"
                  v-model="$v.getConcesionarioId.name.$model"
                />
                <small
                  class="text-danger"
                  v-if="!$v.getConcesionarioId.name.required"
                  >Campo requerido</small
                >
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Correo electrónico">
                <a-input placeholder="Correo electrónico" v-model="$v.getConcesionarioId.email.$model" />
                <small class="text-danger" v-if="!$v.getConcesionarioId.email.required">Campo requerido</small><br>
                <small class="text-danger" v-if="!$v.getConcesionarioId.email.email">Ingresa un email válido</small><br>
                <small class="text-danger" v-if="!validateRegisteredEmail($v.getConcesionarioId.email.$model)">Ya existe un concesionario registrado con este número de correo electrónico</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Teléfono">
                <a-input
                  placeholder="Teléfono"
                  v-model="$v.getConcesionarioId.phoneNumber.$model"
                />
                <small class="text-danger" v-if="!$v.getConcesionarioId.phoneNumber.required">Campo requerido</small><br>
                <small class="text-danger" v-if="!$v.getConcesionarioId.phoneNumber.phoneNumber">Ingresa un número de teléfono válido</small><br>
                <small class="text-danger" v-if="!validateRegisteredPhone($v.getConcesionarioId.phoneNumber.$model)">Ya existe un concesionario registrado con este número de teléfono</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="RFC">
                <a-input placeholder="RFC" v-model="$v.getConcesionarioId.rfc.$model" />
                <small class="text-danger" v-if="!$v.getConcesionarioId.rfc.required">Campo requerido</small><br>
                <small class="text-danger" v-if="!$v.getConcesionarioId.rfc.rfc">Ingresa un RFC válido</small><br>
                <small class="text-danger" v-if="!validateRegisteredRFC($v.getConcesionarioId.rfc.$model)">Ya existe un concesionario registrado con este RFC</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Estado">
                <v-select :options="Object.values(estados)" @input="handleEstadoChange" @select="handleEstadoChange" v-model="$v.getConcesionarioId.address.state.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <!--<a-input
                  placeholder="Estado"
                  v-model="$v.getConcesionarioId.address.state.$model"/>-->
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.state.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Municipio">
                <a-input
                  placeholder="Municipio"
                  v-model="$v.getConcesionarioId.address.city.$model"
                />
                <small class="text-danger" v-if="!$v.getConcesionarioId.address.city.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número Exterior">
                <a-input
                  placeholder="Número Exterior"
                  v-model="$v.getConcesionarioId.address.extNumber.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.extNumber.required">Campo requerido</small>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.extNumber.alphaNum">Ingresa un número exterior válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número Interior">
                <a-input
                  placeholder="Número Interior"
                  v-model="$v.getConcesionarioId.address.intNumber.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.intNumber.alphaNum">Ingresa un número interior válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Código Postal">
                <a-input
                  placeholder="Código Postal"
                  v-model="$v.getConcesionarioId.address.postalCode.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.postalCode.required">Campo requerido</small>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.postalCode.numeric">Ingresa un código postal válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Colonia">
                <a-input
                  placeholder="Colonia"
                  v-model="$v.getConcesionarioId.address.suburb.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.suburb.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Calle">
                <a-input
                  placeholder="Calle"
                  v-model="$v.getConcesionarioId.address.street.$model"/>
                  <small class="text-danger" v-if="!$v.getConcesionarioId.address.street.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredEmail($v.getConcesionarioId.email.$model) && validateRegisteredPhone($v.getConcesionarioId.phoneNumber.$model) && validateRegisteredRFC($v.getConcesionarioId.rfc.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
// import { encrypt } from '@/config/headers'
import { required, helpers, alphaNum, numeric } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const phoneNumber = helpers.regex('phone', /^[0-9]{10}$/)
const rfc = helpers.regex('rfc', /([A-ZÑa-zñ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Za-z0-9])([A-Za-z0-9])([A-Za-z0-9])?)$/)
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
const GET_CONCESIONARIOS = gql`
  query getConcesionarios{
    getConcesionarios{
      id
      rfc
      email
      phoneNumber
    }
  }
`
export default {
  data: function () {
    return {
      disabledButton: false,
      error: null,
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      getConcesionarioId: {
        name: '',
        email: '',
        phoneNumber: '',
        rfc: '',
        address: {
          city: '',
          extNumber: '',
          intNumber: '',
          postalCode: '',
          state: '',
          suburb: '',
          street: '',
        },
        tripsAvailable: 0,
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredRFC: {},
      registeredPhone: {},
      registeredEmail: {},
      estados: ['Ciudad de México', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Coahuila de Zaragoza', 'Colima', 'Chiapas', 'Chihuahua', 'Durango', 'Guanajuato', 'Guerrero',
        'Hidalgo', 'Jalisco', 'México', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
        'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'],
      municipios: [],
      codigos: [],
      colonias: [],
      data: {},
    }
  },
  apollo: {
    getConcesionarioId: {
      query: gql`
        query getConcesionarioId($id: Int!) {
          getConcesionarioId(id: $id) {
            id
            name
            email
            phoneNumber
            rfc
            address {
              id
              city
              extNumber
              intNumber
              postalCode
              state
              suburb
              street
            }
            tripsAvailable
          }
        }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      variables() {
        return {
          id: this.id ? parseInt(this.id) : 1,
        }
      },
      skip() {
        return this.skipQuery
      },
      result({ data }) {
        this.getConcesionarioId.phoneNumber = data.getConcesionarioId.phoneNumber.replace('+52', '')
        const emailEdition = this.getConcesionarioId.email
        const rfcEdition = this.getConcesionarioId.rfc
        const phoneEdition = this.getConcesionarioId.phoneNumber
        this.$apollo.query({ query: GET_CONCESIONARIOS, context: headers() })
          .then(({ data }) => {
            data.getConcesionarios.forEach(concesionario => {
              this.registeredRFC[concesionario.rfc] = 1
              this.registeredPhone[concesionario.phoneNumber] = 1
              this.registeredEmail[concesionario.email] = 1
            })
            delete this.registeredEmail[emailEdition]
            delete this.registeredPhone['+52' + phoneEdition]
            delete this.registeredRFC[rfcEdition]
            // console.log(this.registeredRFC)
            // console.log(this.registeredPhone)
            // console.log(this.registeredEmail)
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  },
  methods: {
    async addConcesionario() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      if (this.id != null) {
        await this.$apollo.mutate({
          mutation: gql`mutation updateConcesionario($idEdit: Int, $name: String, $email: String, $phoneNumber: String, $rfc: String, $tripsAvailable: Int, $city: String, $extNumber: String, $intNumber: String, $postalCode: String, $state: String, $suburb: String, $street: String) {
         updateConcesionario(id: $idEdit, concesionario: {
          name: $name
          email: $email
          phoneNumber: $phoneNumber
          rfc: $rfc
          tripsAvailable: $tripsAvailable
          address:{
            city: $city
            extNumber: $extNumber
            intNumber: $intNumber
            postalCode: $postalCode
            state: $state
            suburb: $suburb
            street: $street
          }
        }){
          name
          email
          phoneNumber
          rfc
          tripsAvailable
          address{
            city
            extNumber
            intNumber
            postalCode
            state
            suburb
            street
          }
        }
        }`,
          context: headers(),
          variables: {
            idEdit: parseInt(this.id),
            name: this.getConcesionarioId.name,
            email: this.getConcesionarioId.email,
            phoneNumber: '+52' + this.getConcesionarioId.phoneNumber,
            rfc: this.getConcesionarioId.rfc,
            city: this.getConcesionarioId.address.city,
            extNumber: this.getConcesionarioId.address.extNumber,
            intNumber: this.getConcesionarioId.address.intNumber,
            postalCode: this.getConcesionarioId.address.postalCode,
            state: this.getConcesionarioId.address.state,
            suburb: this.getConcesionarioId.address.suburb,
            street: this.getConcesionarioId.address.street,
            tripsAvailable: 0, // parseInt(this.getConcesionarioId.tripsAvailable),
          },
        })
          .then(res => {
            this.$router.push('/concesionarios/getFranchises')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error)
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      } else {
        await this.$apollo.mutate({
          mutation: gql`mutation addConcesionario($name: String, $email: String, $phoneNumber: String, $rfc: String, $tripsAvailable: Int, $city: String, $extNumber: String, $intNumber: String, $postalCode: String, $state: String, $suburb: String, $street: String) {
         addConcesionario(concesionario: {
          name: $name
          email: $email
          phoneNumber: $phoneNumber
          rfc: $rfc
          tripsAvailable: $tripsAvailable
          address:{
            city: $city
            extNumber: $extNumber
            intNumber: $intNumber
            postalCode: $postalCode
            state: $state
            suburb: $suburb
            street: $street
          }
        }){
          name
          email
          phoneNumber
          rfc
          tripsAvailable
          address{
            city
            extNumber
            intNumber
            postalCode
            state
            suburb
            street
          }
        }
        }`,
          context: headers(),
          variables: {
            name: this.getConcesionarioId.name,
            email: this.getConcesionarioId.email,
            phoneNumber: '+52' + this.getConcesionarioId.phoneNumber,
            rfc: this.getConcesionarioId.rfc,
            city: this.getConcesionarioId.address.city,
            extNumber: this.getConcesionarioId.address.extNumber,
            intNumber: this.getConcesionarioId.address.intNumber,
            postalCode: this.getConcesionarioId.address.postalCode,
            state: this.getConcesionarioId.address.state,
            suburb: this.getConcesionarioId.address.suburb,
            street: this.getConcesionarioId.address.street,
            tripsAvailable: 0, // parseInt(this.getConcesionarioId.tripsAvailable),
          },
        })
          .then(res => {
            this.$router.push('/concesionarios/getFranchises')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error)
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredPhone(phone) {
      if (this.registeredPhone['+52' + phone]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredRFC(rfc) {
      if (this.registeredRFC[rfc.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredEmail(email) {
      if (this.registeredEmail[email.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.$apollo.queries.getConcesionarioId.skip = false
    } else {
      this.$apollo.query({ query: GET_CONCESIONARIOS /*, context: { headers: encrypt(new Date().getTime()) } */ })
        .then(({ data }) => {
          data.getConcesionarios.forEach(concesionario => {
            this.registeredRFC[concesionario.rfc] = 1
            this.registeredPhone[concesionario.phoneNumber] = 1
            this.registeredEmail[concesionario.email] = 1
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  validations: {
    getConcesionarioId: {
      name: { required },
      email: { required, email },
      phoneNumber: { phoneNumber, required },
      rfc: { required, rfc },
      address: {
        city: { required },
        state: { required },
        extNumber: { required, alphaNum },
        intNumber: { alphaNum },
        postalCode: { required, numeric },
        suburb: { required },
        street: { required },
      },
    },
  },
}
</script>
